/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { AiOutlineClockCircle, AiOutlineStar } from 'react-icons/ai';
import Switch from 'react-switch';
import ReactPaginate from 'react-paginate';
import ManajemenMateriController, {
  useManajemenMateriContext,
} from '../../../../controller/admin/manajemen_materi/index';
import { If, Then, Else } from 'react-if';
import Shimmer from 'react-shimmer-effect';
import { Materi } from '../../../../../../entities/Materi';
import Select from 'react-select';
import SidebarWithHeader from '../../../../components/Admin/SidebarWithHeader';
import { Box, Grid, Text, GridItem, InputGroup, InputLeftElement, Input } from '@chakra-ui/react';
import { FaSearch } from 'react-icons/fa';
import { useRole } from '../../../../../hooks/useRole';

const BottomHeader: React.FC = () => {
  const {
    listJenisPelatihan,
    jenjang,
    jenjangList,
    checkAll,
    checkVideo,
    checkPDF,
    checkPPT,
    checkAudio,
    jenis_materi_id,
  } = useManajemenMateriContext().state;
  const {
    searchMateri,
    filterJenisPelatihan,
    filterJenjang,
    filterJenisMateri,
    filterSemuaJenisMateri,
    clearAllFilters,
  } = useManajemenMateriContext();
  const { canMutate } = useRole();

  let optionsJenisPelatihan;

  if (listJenisPelatihan.length > 0) {
    optionsJenisPelatihan = listJenisPelatihan.map((item) => ({
      value: item.id,
      label: item.nama_pelatihan,
    }));
  } else {
    optionsJenisPelatihan = [];
  }

  const selectedOption = optionsJenisPelatihan.find(opt => opt.value === jenis_materi_id);

  const optionsJenjang = jenjangList.map((item) => ({
    value: item.jenjang,
    label: item.jenjang,
  }));

  const selectedJenjang = optionsJenjang.find(opt => opt.value === jenjang);

  return (
    <div>
      <div className="w-full bg-white flex flex-wrap px-5 py-2">
        <div
          className="mr-4 mt-2 flex flex-wrap justify-between border border-gray-300 rounded px-2 py-2"
          style={{ width: '177px' }}
        >
          <a>Semua</a>
          <input
            type="checkbox"
            className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-gren-600 checked:border-gren-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            onChange={() => filterSemuaJenisMateri(!checkAll)}
            checked={checkAll}
          />
        </div>
        <div
          className="mr-4 mt-2 flex flex-wrap justify-between border border-gray-300 rounded px-2 py-2"
          style={{ width: '177px' }}
        >
          <a>Video</a>
          <input
            type="checkbox"
            className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-gren-600 checked:border-gren-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            onChange={(e) => filterJenisMateri(!checkVideo, 'video')}
            checked={checkVideo}
          />
        </div>
        <div
          className="mr-4 mt-2 flex flex-wrap justify-between border border-gray-300 rounded px-2 py-2"
          style={{ width: '177px' }}
        >
          <a>PDF</a>
          <input
            type="checkbox"
            className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-gren-600 checked:border-gren-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            onChange={(e) => filterJenisMateri(!checkPDF, 'pdf')}
            checked={checkPDF}
          />
        </div>
        <div
          className="mr-4 mt-2 flex flex-wrap justify-between border border-gray-300 rounded px-2 py-2"
          style={{ width: '177px' }}
        >
          <a>PPT</a>
          <input
            type="checkbox"
            className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-gren-600 checked:border-gren-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            onChange={(e) => filterJenisMateri(!checkPPT, 'ppt')}
            checked={checkPPT}
          />
        </div>
        <div
          className="mt-2 flex flex-wrap justify-between border border-gray-300 rounded px-2 py-2"
          style={{ width: '177px' }}
        >
          <a>Audio</a>
          <input
            type="checkbox"
            className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-gren-600 checked:border-gren-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
            onChange={(e) => filterJenisMateri(!checkAudio, 'audio')}
            checked={checkAudio}
          />
        </div>
      </div>
      <hr />
      <div className="w-full bg-white flex flex-wrap items-center justify-between gap-3 px-5 py-3">
          <div className="flex items-center gap-3">
            <div className="w-56">
              <Select
                key={jenis_materi_id}
                options={optionsJenisPelatihan}
                value={jenis_materi_id ? selectedOption : null}
                onChange={(val: any) =>
                  filterJenisPelatihan(val ? val.value : '')
                }
                placeholder="Nama Pelatihan (Jenis Pelatihan)"
                isClearable={true}
                menuPortalTarget={document.body}
              />
            </div>
            <div className="w-36">
              <Select
                key={jenjang}
                options={optionsJenjang}
                value={jenjang ? selectedJenjang : null}
                onChange={(val: any) => filterJenjang(val ? val.value : '')}
                placeholder="Jenjang"
                isClearable={true}
                menuPortalTarget={document.body}
              />
            </div>
            {/* Clear Filter */}
            <button
              onClick={() => clearAllFilters()}
              className="px-4 py-2.5 rounded border border-green-300 text-green-500 font-semibold text-xs cursor-pointer active:bg-gray-300 transition duration-300 ease hover:bg-green-600 hover:text-white"
            >
              Clear Filter
            </button>
          </div>
          <div className="flex items-center gap-3">
            <InputGroup w="220px">
              <InputLeftElement pointerEvents="none">
                <FaSearch />
              </InputLeftElement>
              <Input
                type="search"
                placeholder="Cari Disini..."
                onChange={(e) => searchMateri(e.target.value)}
              />
            </InputGroup>
            {canMutate && (
              <a
                href="/admin/tambah/manajemen_materi"
                className="flex px-5 bg-green-600 text-white font-semibold text-xs leading-tight rounded shadow-md hover:bg-green-700"
                style={{ height: '38px', alignItems: 'center' }}
              >
                Tambah Baru
                <BsFillPlusCircleFill className="ml-2" />
              </a>
            )}
          </div>
        </div>
    </div>
  );
};

const Pagination = () => {
  const { setPage } = useManajemenMateriContext();
  const { jumlahPage } = useManajemenMateriContext().state;

  let endFix =
    jumlahPage > Number(jumlahPage.toFixed())
      ? Number(jumlahPage.toFixed()) + 1
      : Number(jumlahPage.toFixed());

  const handlePageClick = (event) => {
    setPage(event.selected);
  };

  return (
    <If condition={endFix > 1}>
      <Then>
        <div className="flex justify-center mt-5">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Selanjutnya"
            activeClassName="active"
            containerClassName="pagination"
            onPageChange={handlePageClick}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            pageCount={
              jumlahPage > Number(jumlahPage.toFixed())
                ? Number(jumlahPage.toFixed()) + 1
                : Number(jumlahPage.toFixed())
            }
            previousLabel="Sebelumnya"
          />
        </div>
      </Then>
      <Else>
        <></>
      </Else>
    </If>
  );
};

const ItemMateri = ({ materi }: { materi: Materi }) => {
  return (
    <div className="sm:col-span-3 md:col-span-2 lg:col-span-1  w-full">
      <div
        className="rounded-lg bg-white hover:shadow-lg transition-all duration-300"
        style={{ height: '250px' }}
      >
        <div className="relative">
          <img
            className="z-10 rounded-t-lg w-full"
            src={materi.path_thumbnail}
            alt=""
            style={{ height: '119px', objectFit: 'cover' }}
          />
        </div>
        <div className="px-6 pb-6 pt-3">
          <a
            className="text-gray-900 text-base font-medium mb-2"
            href={`/admin/detail/manajemen_materi/${materi.id}`}
          >
            {materi.judul_materi.length > 30
              ? materi.judul_materi.substring(0, 30) + '...'
              : materi.judul_materi}
          </a>
          {/* Count Tanggal Ditambahkan */}
          <div className="flex flex-rows mt-2">
            <AiOutlineClockCircle
              className="mr-3 text-md"
              style={{ marginTop: '4px' }}
            />
            <p className="text-sm">{materi.tanggal_pembuatan}</p>
          </div>

          {/* Deskripsi */}
          {/* <p className="mt-3 text-xs">{parse(materi.uraian_deskripsi)}</p> */}

          {/* Preview & Stars */}
          <div className="flex justify-between mt-3">
            <div className="flex flex-rows mt-3n">
              <div className="flex flex-rows">
                <AiOutlineStar className="mr-2 text-sm text-yellow-400 " />
                <p className="text-xs">{materi.rating}</p>
              </div>
            </div>
            <div>
              <Switch
                className="ml-2"
                height={20}
                onChange={() => {}}
                checked={materi.status_publish == 1 ? true : false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const WrapperMain: React.FC = () => {
  const { getMateri, getJenisPelatihan, getJenjang } = useManajemenMateriContext();
  const { materi, isLoading } = useManajemenMateriContext().state;

  useEffect(() => {
    getMateri(1, '', '', [], '');
    getJenisPelatihan();
    getJenjang();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SidebarWithHeader title="Manajemen Materi">
      <Box className="app">
        <Box as="main" style={{ padding: '0px' }}>
          <Box mb={4}>
            <BottomHeader />
          </Box>
          <Box className="container" mb={10}>
            <Grid
              templateColumns={{
                base: '1fr',
                sm: 'repeat(1, 1fr)',
                md: 'repeat(4, 1fr)',
                lg: 'repeat(3, 1fr)',
              }}
              gap={4}
            >
              <If condition={isLoading}>
                <Then>
                  {[1, 2, 3, 4, 5, 6].map((i) => {
                    return (
                      <Shimmer key={i}>
                        <Box
                          pl={2}
                          mt={2}
                          w="full"
                          borderRadius="lg"
                          mx={3}
                          h="100px"
                        ></Box>
                      </Shimmer>
                    );
                  })}
                </Then>
                <Else>
                  {materi.length > 0 ? (
                    materi.map((m: Materi) => {
                      return <ItemMateri materi={m} />;
                    })
                  ) : (
                    <GridItem colSpan={3}>
                      <Box textAlign="center" py={10}>
                        <Text fontSize="lg" color="gray.500">
                          Tidak ada data
                        </Text>
                      </Box>
                    </GridItem>
                  )}
                </Else>
              </If>
            </Grid>
            <Pagination />
          </Box>
        </Box>
      </Box>
    </SidebarWithHeader>
  );
};

const ManajemenMateri: React.FC = () => {
  return (
    <ManajemenMateriController.Provider>
      <WrapperMain />
    </ManajemenMateriController.Provider>
  );
};

export default ManajemenMateri;
